<template lang="pug">
.RiskContrastList
  .list_item(v-for="(item, i) in newList", :key="i")
    .title {{ item.eventName }}
    el-button(
      type="primary",
      plain,
      size="mini",
      style="padding: 6px 14px",
      @click="compareEvent(item)",
      :disabled="item.vs"
    ) 对比
  NoData(v-if="list.length === 0")
</template>

<script>
import NoData from '../components/NoData.vue'
import _ from 'lodash'
export default {
  props: { list: Array },
  components: { NoData },
  data () {
    return {
    }
  },
  computed: {
    compareIds () {
      return this.$store.getters.compareIds
    },
    newList () {
      return this.list.map(d => {
        return {
          ...d,
          vs: !!this.compareIds.find(m => m.id === d.id)
        }
      })
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
    compareEvent (l) {
      console.log('this.compareIds:', this.compareIds)
      let data = this.compareIds.slice()
      if (l.vs) {
        l.vs = false
        data = _.reject(data, d => d.id === l.id)
      } else {
        l.vs = true
        if (data.length > 1) {
          this.$message({
            message: '对比事件添加上限',
            type: 'warning',
            center: true
          })
          return false
        }
        data = data.concat(l)
      }
      this.$store.dispatch('updateCompareIds', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.RiskContrastList {
  margin-top: 20px;
  .list_item {
    padding: 0 14px;
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    .title {
      width: 0;
      flex: 1;
      margin-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      color: #666666;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/RiskContrast/RiskContrastList.vue